/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

const mesesAbrev = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

const mostrarFecha = (fechaStr) => {
  if (!fechaStr) return "Ingresar fecha";
  const [, month, day] = fechaStr.split("-");
  return `${day}-${mesesAbrev[parseInt(month) - 1]}`;
};

export const GestionContenidosModal = ({
  isOpen,
  monthIndex,
  selectedYear,
  currentYear,
  mesesCompletos,
  pais,
  localString,
  moneda,
  formatCurrency,
  formatFee,
  getDolarValue,
  convertirAMonedaLocal,
  detalleItems,
  costosGestionData,
  // Props mantenidos por compatibilidad (edición deshabilitada, solo lectura)
  editingFechaId: _editingFechaId,
  setEditingFechaId: _setEditingFechaId,
  editingFechaValue: _editingFechaValue,
  setEditingFechaValue: _setEditingFechaValue,
  onSaveFecha: _onSaveFecha,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  const ultimoDiaMes = new Date(currentYear, monthIndex + 1, 0);
  const fechaUltimoDia = ultimoDiaMes.toISOString().split("T")[0];

  const calcularTotal = () =>
    detalleItems.reduce((sum, item) => {
      const negocioId = Number(item.id);
      const cuotas = item.cuotasFacturadas || 1;
      const fechaFacturaGuardada =
        item.facturaFecha ||
        costosGestionData
          .find(
            (c) =>
              Number(c.negocio_id) === negocioId && Number(c.mes) === monthIndex + 1 && Number(c.ano) === currentYear
          )
          ?.fecha_factura?.split("T")[0] ||
        null;
      const fechaDia1 = `${currentYear}-${String(monthIndex + 1).padStart(2, "0")}-01`;
      const fechaUsada = fechaFacturaGuardada || fechaDia1;
      const gestionMoneda = item.gestionMoneda?.toUpperCase() || "";
      const contenidosMoneda = item.contenidosMoneda?.toUpperCase() || "";
      const totalPantallaOriginal = (item.gestionUnitario || 0) + (item.contenidosUnitario || 0);
      const totalProyectoOriginal = Number((totalPantallaOriginal * item.pantallas * cuotas).toFixed(2));
      const totalLocal = convertirAMonedaLocal(
        totalProyectoOriginal,
        gestionMoneda || contenidosMoneda,
        pais,
        negocioId,
        monthIndex + 1,
        selectedYear,
        fechaUsada
      );
      return sum + totalLocal;
    }, 0);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "1600px", width: "95%", margin: "20px auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>
          Detalle Gestión & Contenidos - {mesesCompletos[monthIndex]} {selectedYear}
        </h3>
        <div style={{ overflowX: "auto" }}>
          <table className={styles.modalTable} style={{ tableLayout: "fixed", minWidth: "1450px" }}>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "5%" }} />
              <col style={{ width: "13%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              {pais === "Perú" && <col style={{ width: "10%" }} />}
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>ID</th>
                <th>TIPO</th>
                <th>CLIENTE / EDIFICIO</th>
                <th>FEE GESTIÓN</th>
                <th>FEE CONTENIDOS</th>
                <th>TOTAL PANTALLA</th>
                <th>PANTALLAS</th>
                <th>TOTAL PROYECTO</th>
                <th>FECHA FACTURA</th>
                {pais === "Perú" && <th>VALOR DÓLAR</th>}
                <th>TOTAL MENSUAL {moneda(pais)}</th>
              </tr>
            </thead>
            <tbody>
              {detalleItems.map((item) => {
                const negocioId = Number(item.id);
                const cuotas = item.cuotasFacturadas || 1;
                const registro = costosGestionData.find(
                  (c) =>
                    Number(c.negocio_id) === negocioId &&
                    Number(c.mes) === monthIndex + 1 &&
                    Number(c.ano) === selectedYear
                );
                const fechaFacturaGuardada = item.facturaFecha || registro?.fecha_factura?.split("T")[0] || null;
                const fechaUsada = fechaFacturaGuardada || fechaUltimoDia;

                const gestionMoneda = item.gestionMoneda?.toUpperCase() || "";
                const contenidosMoneda = item.contenidosMoneda?.toUpperCase() || "";
                const totalPantallaOriginal = (item.gestionUnitario || 0) + (item.contenidosUnitario || 0);
                const totalProyectoOriginal = Number((totalPantallaOriginal * item.pantallas * cuotas).toFixed(2));
                const totalLocal = convertirAMonedaLocal(
                  totalProyectoOriginal,
                  gestionMoneda || contenidosMoneda,
                  pais,
                  negocioId,
                  monthIndex + 1,
                  selectedYear,
                  fechaUsada
                );

                const esUSD = gestionMoneda.includes("US") || contenidosMoneda.includes("US");
                const valorDolar = esUSD ? getDolarValue(fechaUsada) : null;

                return (
                  <tr key={item.id}>
                    <td style={{ textAlign: "center", fontWeight: "600" }}>{item.id}</td>
                    <td style={{ textAlign: "center" }}>{item.tipo}</td>
                    <td style={{ textAlign: "left", paddingLeft: "12px", fontWeight: "500" }}>{item.nombre}</td>
                    <td style={{ textAlign: "center" }}>
                      {item.gestionUnitario > 0 ? formatFee(item.gestionUnitario, item.gestionMoneda) : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.contenidosUnitario > 0 ? formatFee(item.contenidosUnitario, item.contenidosMoneda) : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {totalPantallaOriginal > 0
                        ? totalPantallaOriginal.toLocaleString(localString(pais), {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          " " +
                          (gestionMoneda || contenidosMoneda || "")
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.pantallas}
                      {cuotas > 1 ? ` × ${cuotas} cuotas` : ""}
                    </td>
                    <td style={{ textAlign: "right", color: "#1b5e20", fontWeight: "600" }}>
                      {totalProyectoOriginal.toLocaleString(localString(pais), {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) +
                        " " +
                        (gestionMoneda || contenidosMoneda || "")}
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <span
                        style={{
                          backgroundColor: fechaFacturaGuardada ? "#e8f5e8" : "#ffebee",
                          color: fechaFacturaGuardada ? "#1b5e20" : "#c62828",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "13px",
                          display: "inline-block",
                        }}
                      >
                        {fechaFacturaGuardada ? mostrarFecha(fechaFacturaGuardada) : "Sin fecha"}
                      </span>
                    </td>
                    {pais === "Perú" && (
                      <td style={{ textAlign: "center" }}>
                        {esUSD
                          ? valorDolar.toLocaleString("es-PE", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"}
                      </td>
                    )}
                    <td style={{ textAlign: "right", fontSize: ".9rem", color: "#1b5e20" }}>
                      {formatCurrency(totalLocal)}
                    </td>
                  </tr>
                );
              })}
              <tr style={{ backgroundColor: "#e3f2fd", fontWeight: "bold" }}>
                <td colSpan={pais === "Perú" ? 10 : 9} />
                <td style={{ textAlign: "right", fontSize: "1rem", color: "#1b5e20" }}>
                  {formatCurrency(calcularTotal())}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
